import { RegulationDetail } from './regulation-detail';

export class BulkCloseModel {
    itemIds: Array<number>;
    regulationDetail: RegulationDetail;
    impactId:number;

    constructor() {
        this.itemIds = [];
        this.regulationDetail = new RegulationDetail();
        this.impactId=0;
    }
}